import React from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';
import {
  Wrapper,
  ImageContainer,
  TextContainer,
  Title,
  Text,
  Actions,
  StyledLink,
} from './NoData.styles';

const DATA_SETTINGS = '/settings/data/applications';

export const NoData = () => {
  return (
    <Wrapper>
      <ImageContainer />
      <TextContainer>
        <Title>Application allocation is not defined</Title>
        <Text>Please upload a list of applications and allocate spend</Text>
        <Actions>
          <StyledLink to={DATA_SETTINGS}>
            <ApButtonMain>Upload application data</ApButtonMain>
          </StyledLink>
        </Actions>
      </TextContainer>
    </Wrapper>
  );
};
